<!-- frontend/src/components/AgentChat.vue -->
<template>
  <div v-if="!prdEnv()" class="agent-chat">
    <div class="messages" ref="messagesContainer">
      <div v-for="(msg, index) in messages"
           :key="index"
           :class="['message', msg.role]">
        <strong>{{ msg.role === 'user' ? 'You' : 'Agent' }}:</strong>

        <!-- Regular text content -->
        <span v-if="!msg.ftieList || msg.ftieList.length === 0">{{ msg.content }}</span>

        <!-- FTIE List Table -->
        <div v-if="msg.ftieList && msg.ftieList.length > 0" class="ftie-section">
          <span v-if="msg.content" class="ftie-intro-text">{{ msg.content }}</span>
          <div class="ftie-table-wrapper">
            <div class="ftie-table-header-row">
              <span class="ftie-count-badge">{{ msg.ftieList.length }} ticket{{ msg.ftieList.length > 1 ? 's' : '' }} found</span>
            </div>
            <div class="ftie-table-scroll">
              <table class="ftie-table">
                <thead>
                  <tr>
                    <th>FTIE ID</th>
                    <th>Customer</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Device</th>
                    <th>Status</th>
                    <th>Priority</th>
                    <th>Impact</th>
                    <th>Site</th>
                    <th>Vertical</th>
                    <th>GRO Owner</th>
                    <th>GTC Owner</th>
                    <th>Contact Sales</th>
                    <th>Assign Date</th>
                    <th>Target Date</th>
                    <th>Close Date</th>
                    <th>Close Reason</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ticket, tIdx) in msg.ftieList" :key="tIdx" class="ftie-row">
                    <td class="ftie-id-cell">
                      <span class="ftie-id-badge">{{ ticket.ftie_id }}</span>
                    </td>
                    <td class="ftie-customer-cell">{{ ticket.customer }}</td>
                    <td>{{ ticket.category }}</td>
                    <td>{{ ticket.type }}</td>
                    <td><span class="ftie-device-tag">{{ ticket.device }}</span></td>
                    <td>
                      <span :class="['ftie-status-badge', 'status-' + (ticket.status || '').toLowerCase()]">
                        {{ ticket.status }}
                      </span>
                    </td>
                    <td>
                      <span :class="['ftie-priority-badge', 'priority-' + (ticket.priority || '').toLowerCase()]">
                        {{ ticket.priority }}
                      </span>
                    </td>
                    <td>
                      <span :class="['ftie-impact-badge', 'impact-' + (ticket.impact || '').toLowerCase()]">
                        {{ ticket.impact }}
                      </span>
                    </td>
                    <td>{{ ticket.site }}</td>
                    <td>{{ ticket.vertical }}</td>
                    <td>{{ ticket.gro_owner }}</td>
                    <td>{{ ticket.gtc_owner }}</td>
                    <td>{{ ticket.contact_sales }}</td>
                    <td class="ftie-date-cell">{{ formatDate(ticket.assign_date) }}</td>
                    <td class="ftie-date-cell">{{ formatDate(ticket.target_date) }}</td>
                    <td class="ftie-date-cell">{{ formatDate(ticket.close_date) }}</td>
                    <td>{{ ticket.close_reason }}</td>
                    <td class="ftie-desc-cell" :title="ticket.description">{{ ticket.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div v-if="loading" class="message assistant loading">
        <span>🤖 Thinking...</span>
      </div>
    </div>

    <div class="input-area">
      <input v-model="userInput"
             @keyup.enter="sendMessage"
             placeholder="Ask the agent..."
             :disabled="loading" />
      <button @click="sendMessage" :disabled="loading || !userInput.trim()">
        Send
      </button>
    </div>
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'AgentChat',
    data() {
      return {
        userInput: '',
        messages: [],
        loading: false,
        threadId: null,
      }
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      formatDate(dateStr) {
        if (!dateStr) return '—';
        const d = moment(dateStr.trim());
        return d.isValid() ? d.format('YYYY-MM-DD') : dateStr;
      },

      async sendMessage() {
        console.log("sendMessage");
        let self = this;
        if (!this.userInput.trim()) return;
        const msg = this.userInput.trim();
        this.messages.push({ role: 'user', content: msg })
        this.userInput = ''
        this.loading = true
        const url = self.$root.baseUrl + '/genova-graph/api/agent/chat/';
        console.log(url);
        const request_data = {
          message: this.messages,
          thread_id: this.threadId
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);
            if (response.status === 200) {
              this.threadId = response.data.run_id;

              // Check if the response contains ftie_list
              const ftieList = JSON.parse(response.data.ftie_list || []);
              const textContent = response.data.response || '';

              this.messages.push({
                role: 'assistant',
                content: textContent,
                ftieList: ftieList,
              });
            }
          })
          .catch(err => {
            console.error(err);
            self.$message.exception('Internal Server Error!');
            this.messages.push({
              role: 'assistant',
              content: '⚠️ Error: ',
              ftieList: [],
            })
          })
          .finally(() => {
            this.loading = false;
            this.$nextTick(() => {
              const container = this.$refs.messagesContainer
              container.scrollTop = container.scrollHeight
            })
          });
      },
    },
  }
</script>

<style scoped>
  /* ── FTIE Table Styles ── */
  .ftie-section {
    margin-top: 8px;
    width: 100%;
  }

  .ftie-intro-text {
    display: block;
    margin-bottom: 10px;
    color: inherit;
  }

  .ftie-table-wrapper {
    border: 1px solid #dde3ed;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .ftie-table-header-row {
    display: flex;
    align-items: center;
    padding: 8px 14px;
    background: #f4f7fb;
    border-bottom: 1px solid #dde3ed;
  }

  .ftie-count-badge {
    font-size: 12px;
    font-weight: 600;
    color: #4a6fa5;
    background: #e0eaf7;
    padding: 2px 10px;
    border-radius: 20px;
  }

  .ftie-table-scroll {
    overflow-x: auto;
    max-height: 420px;
    overflow-y: auto;
  }

  .ftie-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12.5px;
    min-width: 1400px;
  }

    .ftie-table thead {
      position: sticky;
      top: 0;
      z-index: 2;
    }

      .ftie-table thead tr {
        background: #2c3e6b;
        color: #fff;
      }

    .ftie-table th {
      padding: 9px 12px;
      font-weight: 600;
      white-space: nowrap;
      text-align: left;
      letter-spacing: 0.3px;
      border-right: 1px solid rgba(255, 255, 255, 0.12);
    }

      .ftie-table th:last-child {
        border-right: none;
      }

    .ftie-table tbody tr.ftie-row {
      border-bottom: 1px solid #edf0f5;
      transition: background 0.15s;
    }

      .ftie-table tbody tr.ftie-row:last-child {
        border-bottom: none;
      }

      .ftie-table tbody tr.ftie-row:hover {
        background: #f0f5ff;
      }

    .ftie-table td {
      padding: 8px 12px;
      vertical-align: middle;
      color: #3a4150;
      border-right: 1px solid #f0f2f7;
      white-space: nowrap;
    }

      .ftie-table td:last-child {
        border-right: none;
      }

  /* ID Badge */
  .ftie-id-badge {
    display: inline-block;
    background: #e8f0fe;
    color: #2c5aba;
    font-weight: 700;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
  }

  /* Customer */
  .ftie-customer-cell {
    font-weight: 500;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Device tag */
  .ftie-device-tag {
    background: #f0f4ff;
    color: #4a5568;
    padding: 2px 7px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
  }

  /* Status badges */
  .ftie-status-badge {
    display: inline-block;
    padding: 2px 9px;
    border-radius: 12px;
    font-size: 11.5px;
    font-weight: 600;
  }

  .status-open {
    background: #d1fadf;
    color: #1a7f3c;
  }

  .status-close,
  .status-closed {
    background: #f0f0f0;
    color: #666;
  }

  .status-pending {
    background: #fff3cd;
    color: #856404;
  }

  .status-in\ progress,
  .status-inprogress {
    background: #cce5ff;
    color: #004085;
  }

  /* Priority badges */
  .ftie-priority-badge {
    display: inline-block;
    padding: 2px 9px;
    border-radius: 12px;
    font-size: 11.5px;
    font-weight: 600;
  }

  .priority-high {
    background: #ffe0e0;
    color: #b91c1c;
  }

  .priority-medium {
    background: #fff3cd;
    color: #92600a;
  }

  .priority-low {
    background: #d1fadf;
    color: #1a7f3c;
  }

  /* Impact badges */
  .ftie-impact-badge {
    display: inline-block;
    padding: 2px 9px;
    border-radius: 12px;
    font-size: 11.5px;
    font-weight: 600;
  }

  .impact-high {
    background: #ffe0e0;
    color: #b91c1c;
  }

  .impact-medium {
    background: #fff3cd;
    color: #92600a;
  }

  .impact-low {
    background: #d1fadf;
    color: #1a7f3c;
  }

  /* Date cells */
  .ftie-date-cell {
    font-variant-numeric: tabular-nums;
    color: #5a6375;
    font-size: 12px;
  }

  /* Description cell — truncated with tooltip */
  .ftie-desc-cell {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #5a6375;
    cursor: help;
  }
</style>



// WEBPACK FOOTER //
// src/components/framework-gen-ai/GraphAgenticFlow.vue